"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueSortEnum = void 0;
var QueueSortEnum;
(function (QueueSortEnum) {
    QueueSortEnum["QueueJoinTime"] = "QueueJoinTime";
    QueueSortEnum["LastInboundMessageAt"] = "LastInboundMessageAt";
    QueueSortEnum["LastOutboundMessageAt"] = "LastOutboundMessageAt";
    QueueSortEnum["Unhandled"] = "Unhandled";
})(QueueSortEnum = exports.QueueSortEnum || (exports.QueueSortEnum = {}));
